import PageHeader from "../components/PageHeader";
import EmptyState from "../components/EmptyState";

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

function formatDate(value) {
  if (!value) return "";
  const date = new Date(DATE_ONLY.test(value) ? `${value}T12:00:00` : value);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    ...(DATE_ONLY.test(value) ? {} : { hour: "numeric", minute: "2-digit" })
  }).format(date);
}

export default function CalendarPage({ calendar }) {
  return (
    <>
      <PageHeader
        eyebrow="Deadlines"
        title="Team Calendar"
        description="Private EYGS Team Calendar, transaction deadlines and team milestones."
      />
      <section className="panel calendar-panel">
        {calendar.length ? calendar.map(event => (
          <div className="calendar-row" key={event.id}>
            <time dateTime={event.date}>{formatDate(event.date)}</time>
            <strong>{event.title}</strong>
            <span>{event.propertyAddress || event.source || ""}</span>
          </div>
        )) : <EmptyState>No upcoming dates.</EmptyState>}
      </section>
    </>
  );
}
